// extracted by mini-css-extract-plugin
export default {"switch":"switch__ipnfG","btn":"btn__06-TG","active":"active__eqnRr","default":"default__foVke","fullWidth":"fullWidth__zBYI+"};